import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { CreateRelocationFromTemplateGuard } from 'app/core/store/edit-relocation-detail/relocation-detail-create-from-template.resolve';
import { EditRelocationTemplateGuard } from 'app/core/store/template/relocation-template-edit.resolve';
import { GetDefinitionsGuard } from '../../core/store/definitions/definitions.resolve';
import { CreateRelocationGuard } from '../../core/store/edit-relocation-detail/relocation-detail-create.resolve';
import { GetRelocationGuard } from '../../core/store/edit-relocation-detail/relocation-detail.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { RelocationEditContainer } from './relocation-edit-container/relocation-edit.container';

const routes: Routes = [
  {
    path: 'relocation/new',
    component: RelocationEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CreateRelocationGuard],
      preventCheckingContractDetails: true,
    },
  },

  {
    path: 'relocation/copy',
    component: RelocationEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [AuthorizationGuard, GetDefinitionsGuard],
      authorization: 'canRelocate',
    },
  },

  {
    path: 'relocation/:etmOrderNumber',
    component: RelocationEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [GetRelocationGuard],
    },
  },

  {
    path: 'relocation/template/new',
    component: RelocationEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CreateRelocationGuard],
      createTemplate: true,
    },
  },

  {
    path: 'relocation/template/edit/:templateId',
    component: RelocationEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [EditRelocationTemplateGuard],
      createTemplate: true,
      type: 'RELOCATION',
    },
  },

  {
    path: 'relocation/template/copy',
    component: RelocationEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [AuthorizationGuard, GetDefinitionsGuard],
      createTemplate: true,
      authorization: 'canRelocate',
    },
  },

  {
    path: 'relocation/new/fromTemplate/:templateId',
    component: RelocationEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CreateRelocationFromTemplateGuard],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RelocationRoutingModule {}
